import { render, staticRenderFns } from "./stock-six-dimension.vue?vue&type=template&id=6d84e634&scoped=true&"
import script from "./stock-six-dimension.vue?vue&type=script&lang=js&"
export * from "./stock-six-dimension.vue?vue&type=script&lang=js&"
import style0 from "./stock-six-dimension.scss?vue&type=style&index=0&id=6d84e634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84e634",
  null
  
)

export default component.exports